module.exports = __webpack_public_path__ + "media/images/pic/anime/sweet-kitties-8b08ca90dfaf892b4db1aa3afba3809d.svg";